import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';
const MobileIcon = (props: SvgProps) => (
  <Svg width={12} height={20} fill='none' {...props}>
    <Path
      fill='#FDFBF9'
      d='M1.657 19.846c-.43 0-.792-.148-1.089-.445a1.48 1.48 0 0 1-.445-1.088V1.688c0-.43.148-.792.445-1.09.297-.296.66-.444 1.09-.444h8.685c.43 0 .792.148 1.089.445.297.297.445.66.445 1.089v16.625c0 .429-.148.792-.445 1.088-.297.297-.66.445-1.09.445H1.658Zm-.61-4.385v2.847c0 .154.063.295.191.423.129.128.27.192.423.192h8.677a.588.588 0 0 0 .424-.192.588.588 0 0 0 .192-.423V15.46H1.046Zm4.952 2.485a.728.728 0 0 0 .531-.222.722.722 0 0 0 .224-.53.728.728 0 0 0-.222-.532.722.722 0 0 0-.53-.224.728.728 0 0 0-.532.223.722.722 0 0 0-.224.53c0 .205.074.383.222.532a.722.722 0 0 0 .53.223Zm-4.953-3.408h9.908V3.531H1.046v11.007Zm0-11.93h9.908v-.916a.588.588 0 0 0-.193-.423.588.588 0 0 0-.423-.192H1.662a.588.588 0 0 0-.424.192.588.588 0 0 0-.192.423v.916Z'
    />
  </Svg>
);
export default MobileIcon;
